
<div class="popup">

    <div>
        {{prompt_Message}}
    </div>
    
    <br>
    
    <mat-progress-bar mode='indeterminate'></mat-progress-bar>

</div>
